export default __webpack_public_path__ + "static/media/KI.c4f6fe68.svg";